
export const showInventoryText = (item) => {
    if (item) {
        return !!((!!item.policyFlag && item.productPolicyList && item.productPolicyList.length > 0)||(!!item.policyVariousFlag && item.policyVariousList && item.policyVariousList.length > 0))
    }
    return false
 
}
export const showInventoryTip = (item) => {
    let remark = []
  if (item) {
      if(item.productPolicyList&&item.productPolicyList.length&&item.productPolicyList[0].remark){
        remark.push(item.productPolicyList[0].remark)
      }
      if(item.policyVariousList&&item.policyVariousList.length){
        item.policyVariousList.forEach(item=>{
           if(item.remark){
             
             remark.push(item.remark)
           }
        })
       
      }

  }
  return !!remark.length?remark.join(';'):''
}

export const getByteLen = str => {
  if (typeof str !== 'string') {
    return 0
  }
  let len = 0
  for (let i = 0; i < str.length; i++) {
      if (str[i].match(/[^\x00-\xff]/ig) != null) {
        len += 2 //如果是全角，占用两个字节
      } else {
        len += 1 //半角占用一个字节
      }
  }
  return len
}